import store from "../../Redux/store";
import { setCarbonFlux, countCarbonFlux } from "./CarbonFlux.reducer";

export function saveListCarbonFlux(records) {
  store.dispatch(setCarbonFlux(records));
}

export function saveCountCarbonFlux(count) {
  store.dispatch(countCarbonFlux(count));
}